import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { ReferenceDataGeneralList, type ReferenceInboxColumn } from '../ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { useCurrencies, type Currency } from './useData';

const List: React.FC = () => {
  const formatDate = moduleConfig.utils.formatDate;
  const columns = useMemo<ReferenceInboxColumn<Currency>[]>(
    () => [
      {
        key: 'code',
        header: 'Code',
        className: 'whitespace-nowrap',
        render: (row) => <span className="font-medium font-mono text-xs tracking-wide">{row.code}</span>,
      },
      {
        key: 'name',
        header: 'Name',
        render: (row) => row.name,
      },
      {
        key: 'symbol',
        header: 'Symbol',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => row.symbol || '',
      },
      {
        key: 'isActive',
        header: 'Active',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Yes' : 'No'}</Badge>
        ),
      },
      {
        key: 'sortOrder',
        header: 'Order',
        className: 'hidden whitespace-nowrap md:table-cell',
        render: (row) => row.sortOrder,
      },
      {
        key: 'createdAt',
        header: 'Created',
        className: 'hidden whitespace-nowrap lg:table-cell',
        render: (row) => formatDate(row.createdAt),
      },
    ],
    [formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useCurrencies}
      columns={columns}
      defaultSort={{ key: 'code', direction: 'asc' }}
      newLabel="New currency"
      getRowLabel={(row) => row.name}
    />
  );
};

export default List;
